var render = function render(){var _vm=this,_c=_vm._self._c;return _c('url-sync',{scopedSlots:_vm._u([{key:"default",fn:function({ updateQuery }){return [_c('gl-keyset-pagination',_vm._b({on:{"prev":function($event){return _vm.onPrev(updateQuery)},"next":function($event){return _vm.onNext(updateQuery)}}},'gl-keyset-pagination',_vm.attrs,false))]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }